// OfferPrice (servicio modify) con una tarifa que ya no está disponible: no se debe mostrar la
// confirmación ni permitir remitir esa oferta. Solo un total negativo lo indica; RLNC06 por sí solo
// mantiene el flujo de variación de tarifa (VariationOferPrice).

export const FARE_UNAVAILABLE_TITLE = "No se puede continuar con la remisión";
export const FARE_UNAVAILABLE_REASON = "La tarifa seleccionada ya no está disponible.";
export const FARE_UNAVAILABLE_ACTION_LABEL = "Volver a cotizar";

const normalize = (value) => `${value == null ? "" : value}`.trim();

const toList = (value) => {
    if (!value) {
        return [];
    }
    return Array.isArray(value) ? value : [value];
};

// Un monto ausente (null, undefined o vacío) no se interpreta como cero ni como negativo.
const isNegativeAmount = (amount) => {
    if (amount == null || normalize(amount) === "") {
        return false;
    }
    const value = Number(amount);
    return Number.isFinite(value) && value < 0;
};

// Totales de la oferta cotizada: successAndWarningsAndAirReservation[].airItineraryPricingInfo.itinTotalFare[].totalFare.
const hasNegativeOfferTotal = (data) =>
    toList(data?.successAndWarningsAndAirReservation).some(reservation =>
        toList(reservation?.airItineraryPricingInfo?.itinTotalFare).some(fare =>
            isNegativeAmount(fare?.totalFare?.amount)));

export const isFareUnavailableResponse = (data) =>
    !!data && hasNegativeOfferTotal(data);
